<template>
  <div class="__scale_aging columns">
    <div class="column is-one-thirds">
      <div class="form">
        <h3 class="details">Species: <strong>Chum</strong></h3>
        <h3 class="details">Sex: <strong>{{scales[currentScale].gender}}</strong></h3>
        <p></p>
        <span v-show="!showAnswer">
          <b-field label="How many annual zones?">
            <b-numberinput v-model="form.zones" :controls="false"></b-numberinput>
          </b-field>
          <b-field label="European notation?">
              <b-numberinput v-model="form.eu" step="0.1" :controls="false"></b-numberinput>
          </b-field>
          <b-field label="Age of salmon?">
            <b-slider v-model="form.age" :min="1" :max="5" ticks></b-slider>
          </b-field>
          <b-button type="is-info" @click="showAnswer = true">Submit</b-button>
        </span>
        <div v-show="showAnswer">
          <p class="info">( Correct | Yours )</p>
          <p>Annual zones:</p>
          <p><strong>{{scales[currentScale].zones}}</strong> | <span :class="scales[currentScale].zones == form.zones ? 'correct':'incorrect'">{{form.zones}}</span></p>
          <p>EU Notation:</p>
          <p><strong>{{scales[currentScale].eu}}</strong> | <span :class="scales[currentScale].eu == form.eu ? 'correct':'incorrect'">{{form.eu}}</span></p>
          <p>Age:</p>
          <p><strong>{{scales[currentScale].age}}</strong> | <span :class="scales[currentScale].age == form.age ? 'correct':'incorrect'">{{form.age}}</span></p>
          <b-button rounded @click="reset()">Try another</b-button>
        </div>
      </div>
    </div>
    <div class="column is-two-thirds">
      <span v-show="currentScale == 0">
        <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
          viewBox="0 0 886 1000" style="enable-background:new 0 0 886 1000;" xml:space="preserve">
        <g id="Scale">
            <image style="overflow:visible;" width="886" height="1000" xlink:href="/img/aging/21-NK6903F004.jpg"  transform="matrix(1 0 0 1 0 0.2286)">
          </image>
        </g>
        <g id="Zones" v-show="showAnswer">
          <g id="layer1_1_" class="st0">
            <path id="path847_1_" class="red" d="M253.9,580.9l19.6-45.7l3.7-34.5l23.3-55.9l47.6-51.2l51.3-15.8l31.7-0.9l36.4,1.9l42.9,26.1
              l22.4,41l30.8,65.2l21.4,40.1l-0.9,39.1l6.5,40.1l-1.9,37.3l-26.1,38.2l-54.1,39.1l-83-105.3L362,615.4l-69-8.4L253.9,580.9z"/>
            <path id="path849_1_" class="orange" d="M253.9,580.9l-123.1-72.7l14.9-36.3l12.1-68.9l34.5-74.5l29.8-50.3l33.6-29.8l41-14.9
              l28-16.8l55-14.9l67.1-2.8l40.1,8.4l29.8,11.2l41,16.8l40.1,32.6l22.4,30.7l23.3,52.2l22.4,51.2l19.6,45.7l19.6,47.5l15.9,43.8
              l4.7,54l-2.8,34.5l9.3,53.1l2.8,47.5l-8.4,47.5l-28.9,45.7l-60.6,65.2l-62.5-68.9l-66.2-72.7l54.1-39.1l26.1-38.2l1.9-37.3
              l-6.5-40.1l0.9-39.1l-74.6-146.3l-42.9-26.1l-36.4-1.9l-31.7,0.9l-51.3,15.8l-47.6,51.2l-23.3,55.9l-3.7,34.5L253.9,580.9z"/>
            <path id="path851_1_" class="yellow" d="M130.8,508.3l-83-48.4L72,430l13.1-76.4l45.7-92.2l51.3-60.6l54.1-48.4l56-25.2l56.9-14
              l37.3-15.8l36.4-5.6l44.8,6.5l40.1,9.3l56.9,17.7l48.5,23.3l18.7,21.4l14.9,16.8l23.3,29.8l13.1,27.9l14,27.9l16.8,47.5l18.7,39.1
              l22.4,33.5l9.3,35.4l13.1,32.6l7.5,14.9l9.3,37.3l11.2,25.2l3.7,55l-2.8,60.6l6.5,58.7l-1.9,52.2l-14.9,63.4l-30.8,48.4l-41,41
              l-21.4,28.9l-65.3-59.6l89.5-110.9l8.4-47.5l-2.8-47.5l-9.3-53.1l-1.9-88.5l-17.7-58.7l-28-63.4l-23.3-52.2l-31.7-66.1L598,267.9
              l-40.1-32.6L487,207.3l-40.1-8.4l-67.1,2.8l-55,14.9l-28,16.8l-41,14.9l-33.6,29.8l-29.8,50.3L157.8,403l-12.1,68.9L130.8,508.3z"
              />
          </g>
        </g>
        <g id="Text" v-show="showAnswer">
          <text transform="matrix(1 0 0 1 225.9817 744.8937)" class="text">Zone 1</text>
          <text transform="matrix(1 0 0 1 47.7629 649.6312)" class="text">Zone 2</text>
          <text transform="matrix(1 0 0 1 720.8177 104.1765)" class="text">Zone 3</text>
          <line class="line" x1="191.1" y1="636" x2="226" y2="472.8"/>
          <line class="line" x1="705.1" y1="91.8" x2="590.5" y2="203.1"/>
          <line class="line" x1="357.8" y1="728.5" x2="519.2" y2="643.8"/>
        </g>
        </svg>
      </span>
      <span v-show="currentScale == 1">
        <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
          viewBox="0 0 894.2 1001" style="enable-background:new 0 0 894.2 1001;" xml:space="preserve">
        <g id="Scale">
          <image style="overflow:visible;" width="900" height="1000" xlink:href="/img/aging/20-NK6903M002.jpg"  transform="matrix(1 0 0 1 0 1)">
          </image>
        </g>
        <g id="Zones"  v-show="showAnswer">
          <g id="layer1" class="st0">
            <path id="path847" class="red" d="M218.1,572.2l44.6-70.2l26.5-45.5l19-35.1l34.1-20.9l66.4-25.6l19-5.7l30.3,0.9l32.2,3.8
              l43.6,18l30.3,41.7l21.8,40.8l19.9,41.7l9.5,19l-3.8,50.3l-14.2,52.1l-24.7,50.3l-50.3,63.5L396.4,631l-52.1-22.8L218.1,572.2z"/>
            <path id="path849" class="orange" d="M218.1,572.2l-70.2-34.1l37-51.2l2.8-51.2l14.2-55l46.5-47.4l42.7-32.2l58.8-21.8l48.4-11.4
              l26.5-18l32.2-0.9l27.5,2.8L531,265l27.5,12.3l46.5,25.6l19,21.8l19,24.7l10.4,27.5l23.7,46.5l30.3,58.8l14.2,38.9l3.8,23.7
              l-7.6,36l-10.4,35.1l-8.5,44.6l-8.5,31.3l-14.2,45.5l-71.1,78.7l-82.5-64.5l50.3-63.5l24.7-50.3l14.2-52.1l3.8-50.3l-51.2-101.5
              L533.8,392l-43.6-18l-62.6-4.7l-85.3,31.3l-34.1,20.9L218.1,572.2z"/>
            <path id="path851" class="yellow" d="M147.9,538.1l-114.7-37l38.9-57.8l2.8-36l11.4-39.8l19.9-53.1l21.8-37.9l30.3-30.3l30.3-19
              l41.7-21.8l63.5-25.6l54-18l37.9-12.3l45.5-13.3l41.7-1.9l54,4.7l47.4,5.7l31.3,21.8l33.2,26.5l26.5,19l31.3,34.1l15.2,16.1
              l15.2,36l15.2,32.2l12.3,9.5l9.5,17.1l9.5,15.2l6.6,21.8l24.7,47.4l22.8,39.8l12.3,41.7l4.7,30.3l0.9,38.9l-11.4,41.7l-15.2,39.8
              l1.9,19l-3.8,39.8l-13.3,34.1l-11.4,39.8l-20.9,33.2L723.5,904l-118.5-88.2l71.1-78.7l31.3-121.4l18-71.1l-18-62.6l-54-105.2
              l-10.4-27.5l-37.9-46.5l-46.5-25.6L531,265l-46.5-13.3l-59.7-1.9l-26.5,18l-48.4,11.4L291.1,301l-42.7,32.2L202,380.7l-14.2,55
              l-2.8,51.2L147.9,538.1z"/>
          </g>
        </g>
        <g id="Text" v-show="showAnswer">
          <text transform="matrix(1 0 0 1 252.3062 725.9271)" class="text">Zone 1</text>
          <text transform="matrix(1 0 0 1 40.8479 668.3004)" class="text">Zone 2</text>
          <text transform="matrix(1 0 0 1 718.9026 158.8456)" class="text">Zone 3</text>
          <line class="line" x1="184.2" y1="654.7" x2="219.1" y2="491.5"/>
          <line class="line" x1="705.2" y1="144" x2="583.6" y2="221.8"/>
          <line class="line" x1="384.1" y1="709.5" x2="545.5" y2="624.9"/>
        </g>
        </svg>
      </span>
      <span v-show="currentScale == 2">
        <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
          viewBox="0 0 900 1000" style="enable-background:new 0 0 900 1000;" xml:space="preserve">
        <g id="Scale">
            <image style="overflow:visible;" width="900" height="1000" xlink:href="/img/aging/11-NS8204F009.jpg" >
          </image>
        </g>
        <g id="Zones" v-show="showAnswer">
          <path id="path847_1_" class="red" d="M252.1,649.6l7.6-77.7l-3.8-29.4l12.3-47.4l8.5-27.5l16.1-21.8l27.5-30.3l39.8-22.7l18-4.7
            l18.9,2.8l53-6.6l37.9,15.2l28.4,37.9l18,24.6l22.7,13.3l36,37.9l21.8,37.9l8.5,44.5l9.5,29.4l1.9,46.4l-9.5,40.7l-26.5,44.5
            l-44.5,53l-81.4-68.2l-18.9-25.6l-89-39.8l-44.5-14.2L252.1,649.6z"/>
          <path id="path849_1_" class="orange" d="M252.1,649.6l-110.8-13.3l9.5-81.4l-6.6-25.6l5.7-53l16.1-40.7l13.3-35l20.8-31.3l53-49.2
            l43.6-36l40.7-17l54-6.6l47.4-1.9l42.6,4.7l35,19.9l27.5,22.7l33.1,53l22.7,28.4l18.9,9.5l26.5,17l22.7,30.3l21.8,16.1l16.1,23.7
            l8.5,21.8l-1.9,27.5l8.5,21.8l4.7,19.9v34.1l9.5,18.9l2.8,29.4l-1.9,31.3l7.6,27.5l-1.9,27.5l-8.5,33.1L718,803l-19.9,26.5
            l-43.6,53l-100.4-72.9l44.5-53l26.5-44.5l9.5-40.7l-1.9-46.4l-9.5-29.4l-8.5-44.5L593,513.2l-36-37.9l-22.7-13.3l-46.4-62.5
            L450,384.4l-53,6.6l-18.9-2.8l-18,4.7l-39.8,22.7L292.8,446l-16.1,21.8l-20.8,74.8l3.8,29.4L252.1,649.6z"/>
          <path id="path851_1_" class="yellow" d="M141.3,636.3l-52.1-20.8l15.2-60.6l-1.9-42.6l-7.6-36.9l10.4-54.9l24.6-44.5l44.5-68.2
            l51.1-45.5l49.2-38.8l42.6-15.2l36-6.6h32.2l43.6-8.5l52.1,7.6l47.4,23.7l47.4,40.7l32.2,46.4l17,27.5l39.8,23.7l31.3,27.5l34.1,54
            l29.4,43.6l7.6,40.7l8.5,53l12.3,53l7.6,52.1l2.8,61.6l-5.7,39.8L767.3,838l-36,37.9l-33.1,47.4l-43.6-40.7L718,803l15.2-26.5
            l8.5-33.1l1.9-27.5l-7.6-27.5l1.9-31.3l-2.8-29.4l-9.5-18.9v-34.1l-4.7-19.9l-8.5-21.8l1.9-27.5l-8.5-21.8l-16.1-23.7l-21.8-16.1
            l-22.7-30.3l-26.5-17l-18.9-9.5l-22.7-28.4l-33.1-53l-27.5-22.7l-35-19.9l-42.6-4.7l-47.4,1.9l-54,6.6l-40.7,17L200,369.3
            l-20.8,31.3l-29.4,75.8l-5.7,53l6.6,25.6L141.3,636.3z"/>
          <path id="path853_1_" class="green" d="M89.2,615.5L39,599.4l9.5-36l0.9-58.7L41.9,445l22.7-73.9l16.1-28.4l39.8-62.5l16.1-24.6
            l38.8-28.4l36-30.3l20.8-31.3l34.1-18l36.9-10.4l46.4-5.7l51.1-1.9l42.6-3.8l36.9,5.7l33.1,12.3l33.1,20.8l29.4,28.4l36,41.7
            l43.6,50.2l49.2,38.8l48.3,50.2l39.8,48.3l25.6,53l19.9,67.2l11.4,52.1l9.5,54.9l6.6,45.5l-4.7,65.3l-2.8,41.7l-12.3,36l-23.7,33.1
            l-30.3,37.9l-52.1,53l-41.7-38.8l33.1-47.4l36-37.9l25.6-50.2l5.7-39.8l-2.8-61.6l-7.6-52.1l-12.3-53l-16.1-93.8l-63.5-97.5
            L665,362.6L625.2,339L576,265.1l-47.4-40.7l-47.4-23.7l-52.1-7.6l-43.6,8.5h-32.2l-36,6.6l-42.6,15.2l-100.4,84.3l-44.5,68.2
            l-24.6,44.5l-10.4,54.9l7.6,36.9l1.9,42.6L89.2,615.5z"/>
        </g>
        <g id="Text" v-show="showAnswer">
          <text transform="matrix(1 0 0 1 269.8209 798.1214)" class="text">Zone 1</text>
          <text transform="matrix(1 0 0 1 120.2071 702.3004)" class="text">Zone 4</text>
          <line class="line" x1="110" y1="687" x2="79.5" y2="512"/>
          <text transform="matrix(1 0 0 1 322.0507 872.1794)" class="text">Zone 2</text>
          <text transform="matrix(1 0 0 1 408.0508 937.1641)" class="text">Zone 3</text>
          <line class="line" x1="479.1" y1="851.9" x2="659.3" y2="770.3"/>
          <line class="line" x1="561" y1="923.4" x2="743.6" y2="827"/>
          <line class="line" x1="407" y1="785" x2="551.2" y2="650.6"/>
        </g>
        </svg>
      </span>
      <span v-show="currentScale == 3">
        <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
          viewBox="0 0 900 1000" style="enable-background:new 0 0 900 1000;" xml:space="preserve">
        <g id="Scale">
          <image style="overflow:visible;" width="900" height="1000" xlink:href="/img/aging/08-QU8603F005.jpg" >
          </image>
        </g>
        <g id="Zones" v-show="showAnswer">
          <path id="path847_1_" class="red" d="M265.5,576.9l4.2-84.1l3.1-47.8l11.4-20.8l20.8-29.1l30.1-34.3l21.8-18.7l38.4-8.3l48.8,10.4
            l37.4,19.7l27,14.5l18.7,16.6l23.9,37.4l26,40.5l22.9,42.6l11.4,54l5.2,38.4L600,657.9l-75.8,87.2l-86.2-74.8l-109.1-55.1
            L265.5,576.9z"/>
          <path id="path1057_1_" class="orange" d="M265.5,576.9l-145.4-48.8l24.9-63.4l7.3-50.9l11.4-37.4l22.9-39.5l40.5-62.3l27-33.2
            l45.7-35.3l23.9-12.5l36.4-7.3l50.9,9.3l13.5,2.1l28,8.3l18.7,9.3L494,231l15.6,16.6l19.7,9.3l26,12.5l33.2,34.3l18.7,14.5
            l14.5,22.9l27,38.4l22.9,28l17.7,41.5l14.5,28l9.3,39.5l13.5,46.7l9.3,36.4l-2.1,46.7l-14.5,64.4l-35.3,62.3l-65.4,67.5l-94.5-95.6
            l75.8-87.2l16.6-49.9l-5.2-38.4l-11.4-54L577.1,473l-49.9-77.9l-18.7-16.6l-64.4-34.3l-48.8-10.4l-38.4,8.3l-21.8,18.7L305,395.1
            L272.8,445L265.5,576.9z"/>
          <path id="path1059_1_" class="yellow" d="M120.1,528.1l-81-27l35.3-86.2l11.4-62.3l23.9-49.9l38.4-60.2l51.9-60.2l51.9-45.7l42.6-24.9
            l35.3-13.5h41.5l30.1,12.5l31.2,3.1l29.1,15.6l36.4,12.5l32.2,31.2l51.9,32.2l36.4,40.5l45.7,41.5l36.4,49.9l37.4,59.2l30.1,61.3
            l15.6,49.9l17.7,68.6l9.3,56.1l2.1,39.5l-16.6,66.5l-18.7,46.7l-36.4,42.6l-20.8,18.7l-43.6,48.8l-58.2-54l65.4-67.5l35.3-62.3
            l14.5-64.4l2.1-46.7l-32.2-122.6l-32.2-69.6l-64.4-89.3l-51.9-48.8l-45.7-21.8L494,231l-22.9-15.6l-18.7-9.3l-28-8.3L360,186.4
            l-36.4,7.3l-23.9,12.5l-45.7,35.3l-27,33.2l-63.4,101.8l-11.4,37.4l-7.3,50.9L120.1,528.1z"/>
        </g>
        <g id="Text" v-show="showAnswer">
          <text transform="matrix(1 0 0 1 241.1936 790.5629)" class="text">Zone 1</text>
          <text transform="matrix(1 0 0 1 62.9748 695.3004)" class="text">Zone 2</text>
          <text transform="matrix(1 0 0 1 736.0296 149.8456)" class="text">Zone 3</text>
          <line class="line" x1="206.3" y1="681.7" x2="223.7" y2="452"/>
          <line class="line" x1="720.3" y1="137.5" x2="592.6" y2="261.5"/>
          <line class="line" x1="373" y1="774.2" x2="538" y2="642"/>
        </g>
        </svg>
      </span>
      <span v-show="currentScale == 4">
        <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
          viewBox="0 0 900 996.8" style="enable-background:new 0 0 900 996.8;" xml:space="preserve">
        <g id="Scale">
          <image style="overflow:visible;" width="900" height="1000" xlink:href="/img/aging/04-NS0702M004.jpg"  transform="matrix(1 0 0 1 0 -1.5833)">
          </image>
        </g>
        <g id="Zones" v-show="showAnswer">
          <path id="path847" class="red" d="M243.4,693.9l-1.6-37.3L226.1,606l-6.4-34.9l2.8-25.6l14.2-42.7l15-31.3l24.2-26.3l36.3-20.6
            l46.3-13.5l37.7-8.5l34.9,3.6l33.5,17.1l41.3,32.8l17.8,9.3l13.5,17.8l31.3,25.6l29.9,46.3l27.8,37.7l11.4,11.4l11.4,24.9l2.8,32.8
            l-29.2,56.3l-21.4,37l-65.5-37.7L482.4,700l-89-17.1l-42-2.1L243.4,693.9z"/>
          <path id="path849" class="orange" d="M243.4,693.9l-93.5,19l-45.6-6.4v-52.7l-17.1-42l-15.7-44.9l-2.8-53.4l12.8-51.3l14.2-32.8
            l20.6-37l20.6-36.3l24.9-27.8l27.1-23.5l27.1-7.8l49.1-19.2l31.3-5.7l21.4-2.1l29.9-5.7l50.6-4.3l36.3,12.1l12.1,7.1l40.6,17.1
            l34.2,24.2l30.6,28.5l32.8,21.4l37,39.9l9.3,13.5l20.6,18.5l23.5,15.7l25.6,31.3l23.5,36.3l12.1,12.1l10.7,17.8l12.1,18.5
            l22.1,23.5l17.8,25.6l9.3,29.2l-0.7,31.3l-7.8,32.8l-39.9,49.1l-19.9,32.8l-15,25.6L655.5,784l-54.1-29.2l50.6-93.3l-2.8-32.8
            l-11.4-24.9l-11.4-11.4l-57.7-84l-31.3-25.6L523.7,465l-17.8-9.3L464.6,423l-33.5-17.1l-34.9-3.6l-84,22.1l-36.3,20.6l-24.2,26.3
            l-15,31.3l-14.2,42.7l-2.8,25.6l6.4,34.9l15.7,50.6L243.4,693.9z"/>
        </g>
        <g id="Text" v-show="showAnswer">
          <text transform="matrix(1 0 0 1 298.9067 787.5629)" class="text">Zone 1</text>
          <text transform="matrix(1 0 0 1 612.387 247.5092)" class="text">Zone 2</text>
          <line class="line" x1="596.7" y1="235.1" x2="482.1" y2="346.4"/>
          <line class="line" x1="435.8" y1="770" x2="579.7" y2="659.7"/>
        </g>
        </svg>
      </span>
    </div>
  </div>
</template>

<script>
import { BButton } from 'buefy/src/components/button';
import { BField } from 'buefy/src/components/field';
import { BNumberinput } from 'buefy/src/components/numberinput';
import { BSlider } from 'buefy/src/components/slider';

export default {
  name: "ScaleAging",
  components: {
    BButton,
    BField,
    BNumberinput,
    BSlider,
  },
  data() {
    return {
      form: {
        zones: null,
        eu: null,
        age: null
      },
      showAnswer: false,
      currentScale: 0,
      scales: [
        {
          zones: 3,
          eu: 0.3,
          age: 4,
          gender: 'female'
        },
        {
          zones: 3,
          eu: 0.3,
          age: 4,
          gender: 'male'
        },
        {
          zones: 4,
          eu: 0.4,
          age: 5,
          gender: 'female'
        },
        {
          zones: 3,
          eu: 0.3,
          age: 4,
          gender: 'female'
        },
        {
          zones: 2,
          eu: 0.2,
          age: 3,
          gender: 'male'
        },
      ],
    };
  },
  methods: {
    reset() {
      this.showAnswer = false
      this.form = {
        zones: null,
        eu: null,
        age: null
      }
      if (this.currentScale + 1 < this.scales.length) {
        this.currentScale += 1;
      } else {
        this.currentScale = 0;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.__scale_aging {
  width: 70%;
  // margin: 0 auto;
  background: white;
  border-radius: 30px;
  box-shadow: 3px 3px 6px #00000030;
  overflow: hidden;

  .form {
    padding: 30px;

    .details {
      font-size: 20px;
      font-weight: 400;
      margin: 5px 0px;
    }
  }

  .column {
    padding: 0;
  }

  svg {
    margin: -10px;
  }

  .red {
    fill: red;
    opacity: 0.45;
  }

  .orange {
    fill: orange;
    opacity: 0.45;
  }

  .yellow {
    fill: yellow;
    opacity: 0.45;
  }

  .green {
    fill: green;
    opacity: 0.45;
  }

  .text {
    fill: black;
    font-size: 40px;
    font-family: Arial, Helvetica, sans-serif;
  }

  .line {
    stroke: black;
    stroke-width:3
  }

  .correct {
    color: green;
    font-weight: 700;
  }

  .incorrect {
    color: red;
    font-weight: 700;
  }

  .info {
    font-size: 12px;
    color: gray;
  }
}
</style>